import React from "react";
import { FiLogOut } from "react-icons/fi";

const LogoutModal = ({ isOpen, onClose, onLogout }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
      <div className="bg-white rounded-3xl max-w-sm w-full shadow-2xl p-8 m-4 transform animate-slideUp">
        <div className="flex flex-col items-center text-center">
          <div className="p-4 bg-red-100 rounded-full mb-4">
            <FiLogOut className="w-8 h-8 text-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            You're about to log out
          </h2>
          <p className="text-gray-600 mb-8">
            Are you sure you want to sign out of your account?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 w-full">
            <button
              type="button"
              onClick={onClose}
              className="w-full py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-xl font-semibold transition-all duration-300"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onLogout}
              className="w-full py-3 px-4 bg-red-600 hover:bg-red-700 text-white rounded-xl font-semibold shadow-md hover:shadow-lg transition-all duration-300"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
